import React from 'react';

import { DateRangeFormatter } from '@gogame/intl-ts';

const FinancialResultTitle = ({
  id,
  businessPartner = {},
  affiliate = {},
  period = [],
  owner = {},
}) => {
  const businessPartnerName =
    businessPartner.id !== undefined ? businessPartner.name : affiliate.name;

  return (
    <React.Fragment>
      <>
        {id}
        {' / '}
      </>
      {businessPartnerName ? (
        <>
          {businessPartnerName}
          {' / '}
        </>
      ) : null}
      {period?.[0] ? (
        <>
          <DateRangeFormatter
            value={period}
            template={'MONTH'}
            timeZone={'utc'}
          />
          {' / '}
        </>
      ) : null}
      by {owner.name}
    </React.Fragment>
  );
};

export default FinancialResultTitle;
